import React from "react";
import {
  AbsoluteFill,
  Audio,
  Img,
  spring,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import {
  Flame,
  ShieldCheck,
  Zap,
  TrendingDown,
  Volume2,
  Skull,
  ArrowRight,
  CheckCircle2,
  Star,
} from "lucide-react";

// --- SUBTITLE DATA (From Whisper Transcription with Exact Frames) ---
const SUBTITLES = [
  { start: 0, end: 88, text: "Dari sekian banyak gamer yang sering top up," },
  { start: 99, end: 210, text: "Kelakuannya pasti masuk salah satu dari 3 pasien ini." },
  { start: 215, end: 315, text: "Pertama, Si Skin Elit Gameplay Sulit." },
  { start: 320, end: 440, text: "Skin wajib tier Collector biar keliatan berwibawa di loading screen." },
  { start: 445, end: 575, text: "Pas masuk game? KDA kosong sepuluh, dibacotin 4 orang." },
  { start: 580, end: 700, text: "Tapi gak masalah, yang penting pas recall efeknya berisik!" },
  { start: 705, end: 785, text: "Kedua, Si Gacha Modal Bismillah." },
  { start: 785, end: 855, text: "Top up ngepas buat 10 kali draw," },
  { start: 855, end: 910, text: "Tapi ngarep dapet skin limited." },
  { start: 915, end: 945, text: "Begitu diputar..." },
  { start: 950, end: 1025, text: "Dapetnya magic dust sama trial card 1 hari." },
  { start: 1030, end: 1135, text: "Abis itu duduk di pinggir kasur, ngelamun mandang langit-langit." },
  { start: 1140, end: 1215, text: "Ketiga, Si Pelampiasan Lose Streak." },
  { start: 1220, end: 1300, text: "Kalah ranked berturut-turut bukannya evaluasi," },
  { start: 1305, end: 1355, text: "Malah top up beli skin baru." },
  { start: 1360, end: 1485, text: "Berharap efek visual mahal bisa nutupin gameplay yang emang beban." },
  { start: 1490, end: 1530, text: "Apapun kelainan lo..." },
  { start: 1535, end: 1630, text: "Kalau mau top up gak pake drama ribet, ke Kyu Store aja." },
  { start: 1630, end: 1730, text: "Proses sat-set, akun aman, langsung lanjut mabar." },
  { start: 1735, end: 1773, text: "Cek link di bio!" },
];

export const KyuStore3Pasien: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Find active subtitle
  const activeSub = SUBTITLES.find(
    (s) => frame >= s.start && frame <= s.end
  );

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0A0A0F",
        fontFamily: "'Inter', sans-serif",
        color: "#FFFFFF",
        overflow: "hidden",
      }}
    >
      {/* AUDIO TRACKS */}
      <Audio src={staticFile("kyustore_3pasien/vo_mastered.mp3")} />

      {/* SFX 1: Vine boom at KDA 0/10/0 */}
      {frame >= 445 && frame < 520 && (
        <Audio
          src={staticFile("kyustore_3pasien/sfx/vine_boom.mp3")}
          volume={0.65}
        />
      )}

      {/* SFX 2: Spongebob fail at magic dust */}
      {frame >= 950 && frame < 1030 && (
        <Audio
          src={staticFile("kyustore_3pasien/sfx/spongebob_fail.mp3")}
          volume={0.7}
        />
      )}

      {/* SFX 3: Vine boom at lose streak */}
      {frame >= 1220 && frame < 1290 && (
        <Audio
          src={staticFile("kyustore_3pasien/sfx/vine_boom.mp3")}
          volume={0.6}
        />
      )}

      {/* SFX 4: Cash register at Kyu Store */}
      {frame >= 1630 && frame < 1700 && (
        <Audio
          src={staticFile("kyustore_3pasien/sfx/cash_register.mp3")}
          volume={0.75}
        />
      )}

      {/* AMBIENT BACKGROUND GLOW */}
      <div
        style={{
          position: "absolute",
          top: -200,
          left: -100,
          width: 800,
          height: 800,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(93,63,211,0.22) 0%, rgba(10,10,15,0) 70%)",
          filter: "blur(90px)",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 200,
          right: -150,
          width: 700,
          height: 700,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(203,98,249,0.15) 0%, rgba(10,10,15,0) 70%)",
          filter: "blur(90px)",
          pointerEvents: "none",
        }}
      />

      {/* MAIN SCENE CONTAINER */}
      <div
        style={{
          position: "absolute",
          top: 250,
          left: 70,
          right: 70,
          height: 1140,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 20,
        }}
      >
        {/* SCENE 1: HOOK (0 - 215f) */}
        {frame < 215 && <HookScene frame={frame} fps={fps} />}

        {/* SCENE 2: PASIEN 1 (215 - 705f) */}
        {frame >= 215 && frame < 705 && (
          <Pasien1Scene frame={frame - 215} fps={fps} />
        )}

        {/* SCENE 3: PASIEN 2 (705 - 1140f) */}
        {frame >= 705 && frame < 1140 && (
          <Pasien2Scene frame={frame - 705} fps={fps} />
        )}

        {/* SCENE 4: PASIEN 3 (1140 - 1490f) */}
        {frame >= 1140 && frame < 1490 && (
          <Pasien3Scene frame={frame - 1140} fps={fps} />
        )}

        {/* SCENE 5: OUTRO (1490 - 1773f) */}
        {frame >= 1490 && <OutroScene frame={frame - 1490} fps={fps} />}
      </div>

      {/* BOTTOM SUBTITLE PILL (SAFE ZONE Y: 1470-1530px) */}
      {activeSub && (
        <div
          style={{
            position: "absolute",
            bottom: 380,
            left: 50,
            right: 50,
            display: "flex",
            justifyContent: "center",
            zIndex: 100,
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              padding: "18px 34px",
              backgroundColor: "rgba(8, 8, 12, 0.96)",
              border: "1.5px solid rgba(255, 255, 255, 0.2)",
              borderRadius: 22,
              boxShadow: "0 18px 52px rgba(0,0,0,0.9)",
              maxWidth: 960,
              textAlign: "center",
            }}
          >
            <span
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 40,
                fontWeight: 900,
                lineHeight: 1.35,
                color: "#FFFFFF",
                letterSpacing: -0.5,
              }}
            >
              {activeSub.text}
            </span>
          </div>
        </div>
      )}

      {/* BOTTOM BRAND WATERMARK WITH LOGO BELOW */}
      <div
        style={{
          position: "absolute",
          bottom: 250,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          zIndex: 40,
        }}
      >
        <div
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 22,
            letterSpacing: 4,
            color: "rgba(255,255,255,0.4)",
            textTransform: "uppercase",
          }}
        >
          KYUSTORE.COM | RESMI DAN AMAN 100%
        </div>
        <Img
          src={staticFile("kyustore_3pasien/visuals/kyu_logo_white.png")}
          style={{ height: 42, objectFit: "contain", opacity: 0.9 }}
        />
      </div>
    </AbsoluteFill>
  );
};

// ==========================================
// SCENE COMPONENTS WITH UPGRADED TYPOGRAPHY
// ==========================================

// --- SCENE 1: HOOK ---
const HookScene: React.FC<{ frame: number; fps: number }> = ({ frame, fps }) => {
  const pop = spring({ frame, fps, config: { damping: 12 } });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        transform: `scale(${pop})`,
        width: "100%",
      }}
    >
      {/* Eyebrow Pill */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 26px",
          backgroundColor: "#5D3FD3",
          borderRadius: 30,
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 26,
          letterSpacing: 2,
          color: "#FFFFFF",
          marginBottom: 24,
        }}
      >
        <Flame size={24} color="#FFE600" />
        AUDIT TONGKRONGAN
      </div>

      {/* Main Massive Headline in Bebas Neue */}
      <h1
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 116,
          fontWeight: 400,
          lineHeight: 0.94,
          letterSpacing: 3,
          margin: 0,
          marginBottom: 24,
          textTransform: "uppercase",
        }}
      >
        3 TIPE PASIEN
        <br />
        <span
          style={{
            background: "linear-gradient(135deg, #CB62F9 0%, #5D3FD3 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          TOP UP GAME
        </span>
      </h1>

      <p
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 28,
          fontWeight: 600,
          color: "rgba(255,255,255,0.75)",
          maxWidth: 780,
          lineHeight: 1.45,
          margin: 0,
          marginBottom: 44,
        }}
      >
        Dari sekian banyak gamer yang sering top up, kelakuannya pasti masuk salah
        satu dari tiga ini.
      </p>

      {/* 3 Mini Cards Preview */}
      <div style={{ display: "flex", gap: 20, width: "100%", justifyContent: "center" }}>
        {[
          { num: "01", title: "SKIN ELIT", sub: "Gameplay Sulit", color: "#FF3B30" },
          { num: "02", title: "GACHA", sub: "Modal Bismillah", color: "#FF9500" },
          { num: "03", title: "LOSE STREAK", sub: "Pelampiasan", color: "#CB62F9" },
        ].map((item, idx) => {
          const cardPop = spring({
            frame: frame - idx * 10,
            fps,
            config: { damping: 10 },
          });
          return (
            <div
              key={item.num}
              style={{
                flex: 1,
                padding: "24px 18px",
                backgroundColor: "rgba(255,255,255,0.05)",
                border: "1.5px solid rgba(255,255,255,0.14)",
                borderRadius: 22,
                transform: `scale(${Math.max(0, cardPop)})`,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 44,
                  lineHeight: 1,
                  color: item.color,
                  letterSpacing: 2,
                  marginBottom: 6,
                }}
              >
                {item.num}
              </div>
              <div
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 34,
                  letterSpacing: 1.5,
                  marginBottom: 6,
                  color: "#FFF",
                }}
              >
                {item.title}
              </div>
              <div
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 18,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.6)",
                }}
              >
                {item.sub}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// --- SCENE 2: PASIEN 1 (Skin Elit Gameplay Sulit) ---
const Pasien1Scene: React.FC<{ frame: number; fps: number }> = ({ frame, fps }) => {
  const pop = spring({ frame, fps, config: { damping: 12 } });
  const punchlineFrame = 230; // ~445f total
  const isPunchline = frame >= punchlineFrame;
  const punchlineSpring = spring({
    frame: frame - punchlineFrame,
    fps,
    config: { damping: 9, mass: 0.6 },
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        transform: `scale(${pop})`,
      }}
    >
      {/* Eyebrow & Title */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          marginBottom: 18,
        }}
      >
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            padding: "6px 18px",
            backgroundColor: "#FF3B30",
            borderRadius: 10,
            fontSize: 26,
            letterSpacing: 2,
            color: "#FFF",
          }}
        >
          PASIEN 01
        </span>
        <h2
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 66,
            letterSpacing: 2,
            margin: 0,
            color: "#FFF",
          }}
        >
          SKIN ELIT, GAMEPLAY SULIT
        </h2>
      </div>

      {/* Main Visual Card */}
      <div
        style={{
          position: "relative",
          width: 640,
          height: 640,
          backgroundColor: "#161622",
          borderRadius: 32,
          border: "2px solid rgba(203, 98, 249, 0.55)",
          overflow: "hidden",
          boxShadow: "0 28px 70px rgba(0,0,0,0.8)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Collector Skin Card Image */}
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <Img
            src={staticFile("kyustore_3pasien/visuals/gusion_collector_card.jpg")}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: isPunchline ? "grayscale(40%) brightness(0.6)" : "none",
            }}
          />

          {/* Badge Collector */}
          <div
            style={{
              position: "absolute",
              top: 24,
              left: 24,
              padding: "10px 22px",
              backgroundColor: "rgba(0,0,0,0.92)",
              border: "2px solid #FFE600",
              borderRadius: 14,
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: 26,
              letterSpacing: 2,
              color: "#FFE600",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <Star size={22} fill="#FFE600" color="#FFE600" />
            COLLECTOR TIER
          </div>

          {/* Loading Screen Quote */}
          <div
            style={{
              position: "absolute",
              bottom: 24,
              left: 24,
              right: 24,
              padding: "18px 24px",
              backgroundColor: "rgba(0,0,0,0.92)",
              backdropFilter: "blur(14px)",
              borderRadius: 18,
              border: "1.5px solid rgba(255,255,255,0.2)",
            }}
          >
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 14,
                color: "#FFE600",
                fontWeight: 800,
                letterSpacing: 1.5,
                marginBottom: 4,
                textTransform: "uppercase",
              }}
            >
              LOADING SCREEN FLEX
            </div>
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 26,
                fontWeight: 800,
                fontStyle: "italic",
              }}
            >
              "Biar keliatan disegani & berwibawa"
            </div>
          </div>

          {/* PUNCHLINE OVERLAY (KDA 0/10/0 & BRONZE COKLAT) */}
          {isPunchline && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(10, 0, 5, 0.85)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transform: `scale(${Math.max(0, punchlineSpring)})`,
                padding: 30,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "5px 16px",
                  backgroundColor: "#FF3B30",
                  borderRadius: 16,
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 20,
                  letterSpacing: 1.5,
                  marginBottom: 10,
                }}
              >
                <Skull size={18} /> PAS MASUK GAMEPLAY
              </div>

              {/* Sleek Balanced KDA Badge */}
              <div
                style={{
                  padding: "10px 24px",
                  backgroundColor: "rgba(255, 59, 48, 0.15)",
                  border: "1.5px solid rgba(255, 59, 48, 0.4)",
                  borderRadius: 16,
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 54,
                    fontWeight: 400,
                    color: "#FF3B30",
                    letterSpacing: 3,
                    lineHeight: 1,
                  }}
                >
                  KDA 0 / 10 / 0
                </div>
              </div>

              <div
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 20,
                  fontWeight: 700,
                  color: "rgba(255, 255, 255, 0.9)",
                  marginBottom: 16,
                }}
              >
                Dibacotin 4 Orang Sekaligus
              </div>

              {/* Bronze Medal Badge */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  backgroundColor: "rgba(0,0,0,0.85)",
                  padding: "12px 22px",
                  borderRadius: 18,
                  border: "1.5px solid #CD7F32",
                }}
              >
                <Img
                  src={staticFile("kyustore_3pasien/visuals/bronze_medal.png")}
                  style={{ width: 48, height: 48, objectFit: "contain" }}
                />
                <div style={{ textAlign: "left" }}>
                  <div
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: 13,
                      color: "#CD7F32",
                      fontWeight: 800,
                      letterSpacing: 1.5,
                      textTransform: "uppercase",
                    }}
                  >
                    SCORE: 3.0 (MEDAL COKLAT)
                  </div>
                  <div
                    style={{
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: 26,
                      letterSpacing: 1.5,
                      color: "#FFF",
                    }}
                  >
                    BEBAN RESMI TIM
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Recall Note */}
      <div
        style={{
          marginTop: 22,
          padding: "16px 36px",
          backgroundColor: "rgba(93, 63, 211, 0.25)",
          border: "2px solid rgba(123, 92, 250, 0.6)",
          borderRadius: 24,
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        <Volume2 size={32} color="#CB62F9" />
        <span
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 26,
            fontWeight: 800,
            color: "#FFFFFF",
            letterSpacing: 0.2,
          }}
        >
          Yang penting pas recall efeknya berisik!
        </span>
      </div>
    </div>
  );
};

// --- SCENE 3: PASIEN 2 (Gacha Modal Bismillah) ---
const Pasien2Scene: React.FC<{ frame: number; fps: number }> = ({ frame, fps }) => {
  const pop = spring({ frame, fps, config: { damping: 12 } });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        transform: `scale(${pop})`,
      }}
    >
      {/* Eyebrow & Title */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          marginBottom: 18,
        }}
      >
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            padding: "6px 18px",
            backgroundColor: "#FF9500",
            borderRadius: 10,
            fontSize: 26,
            letterSpacing: 2,
            color: "#FFF",
          }}
        >
          PASIEN 02
        </span>
        <h2
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 66,
            letterSpacing: 2,
            margin: 0,
            color: "#FFF",
          }}
        >
          GACHA MODAL BISMILLAH
        </h2>
      </div>

      {/* Main Split Grid */}
      <div style={{ display: "flex", gap: 24, width: "100%", justifyContent: "center" }}>
        {/* Left: Top Up Draw Expectation */}
        <div
          style={{
            width: 430,
            backgroundColor: "#161622",
            borderRadius: 30,
            padding: 26,
            border: "2px solid rgba(255,255,255,0.18)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 15,
              color: "#FF9500",
              fontWeight: 800,
              letterSpacing: 1.8,
              marginBottom: 14,
              textTransform: "uppercase",
            }}
          >
            EKSPEKTASI GAMER
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              padding: "16px 22px",
              backgroundColor: "rgba(255,255,255,0.08)",
              borderRadius: 20,
              marginBottom: 16,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Img
              src={staticFile("kyustore_3pasien/visuals/mlbb_diamond.png")}
              style={{ width: 44, height: 44 }}
            />
            <span
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 38,
                letterSpacing: 1.5,
              }}
            >
              TOP UP 10X DRAW
            </span>
          </div>

          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 19,
              fontStyle: "italic",
              fontWeight: 600,
              color: "rgba(255,255,255,0.75)",
              margin: 0,
            }}
          >
            "Ngarep dapet skin limited sekali putar..."
          </p>

          <div
            style={{
              marginTop: 26,
              padding: "20px 18px",
              backgroundColor: "rgba(255,59,48,0.16)",
              border: "2px solid rgba(255,59,48,0.4)",
              borderRadius: 20,
              width: "100%",
            }}
          >
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 14,
                color: "#FF3B30",
                fontWeight: 800,
                letterSpacing: 1.5,
                textTransform: "uppercase",
              }}
            >
              REALITA GACHA:
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
                marginTop: 12,
              }}
            >
              <Img
                src={staticFile("kyustore_3pasien/visuals/magic_dust.png")}
                style={{ width: 52, height: 52 }}
              />
              <div style={{ textAlign: "left" }}>
                <div
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 34,
                    letterSpacing: 1.5,
                    lineHeight: 1.1,
                  }}
                >
                  MAGIC DUST +5
                </div>
                <div
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 17,
                    fontWeight: 700,
                    color: "rgba(255,255,255,0.7)",
                  }}
                >
                  + Trial Card 1 Hari
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Pablo Escobar Staring at Ceiling */}
        <div
          style={{
            width: 470,
            backgroundColor: "#161622",
            borderRadius: 30,
            overflow: "hidden",
            border: "2px solid rgba(255,255,255,0.18)",
            position: "relative",
          }}
        >
          <Img
            src={staticFile("kyustore_3pasien/visuals/sad_pablo_escobar.jpg")}
            style={{ width: "100%", height: 440, objectFit: "cover" }}
          />
          <div
            style={{
              padding: 22,
              backgroundColor: "#12121A",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                color: "#FFE600",
                fontWeight: 800,
                letterSpacing: 1.8,
                textTransform: "uppercase",
              }}
            >
              PASCA GACHA:
            </div>
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 24,
                fontWeight: 800,
                marginTop: 6,
                lineHeight: 1.35,
              }}
            >
              Duduk di pinggir kasur, ngelamun mandang langit-langit
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- SCENE 4: PASIEN 3 (Pelampiasan Lose Streak) ---
const Pasien3Scene: React.FC<{ frame: number; fps: number }> = ({ frame, fps }) => {
  const pop = spring({ frame, fps, config: { damping: 12 } });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        transform: `scale(${pop})`,
      }}
    >
      {/* Eyebrow & Title */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          marginBottom: 18,
        }}
      >
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            padding: "6px 18px",
            backgroundColor: "#CB62F9",
            borderRadius: 10,
            fontSize: 26,
            letterSpacing: 2,
            color: "#FFF",
          }}
        >
          PASIEN 03
        </span>
        <h2
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 66,
            letterSpacing: 2,
            margin: 0,
            color: "#FFF",
          }}
        >
          PELAMPIASAN LOSE STREAK
        </h2>
      </div>

      {/* Main Grid: Defeat History + Clown Makeup */}
      <div style={{ display: "flex", gap: 24, width: "100%", justifyContent: "center" }}>
        {/* Left: 5x Lose Streak Column */}
        <div
          style={{
            width: 430,
            backgroundColor: "#161622",
            borderRadius: 30,
            padding: 24,
            border: "2px solid rgba(255, 59, 48, 0.45)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <span
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 16,
                color: "#FF3B30",
                fontWeight: 800,
                letterSpacing: 1.8,
              }}
            >
              MATCH HISTORY
            </span>
            <span
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 22,
                letterSpacing: 1.5,
                backgroundColor: "rgba(255,59,48,0.3)",
                padding: "4px 12px",
                borderRadius: 8,
                color: "#FF3B30",
              }}
            >
              5X DEFEAT
            </span>
          </div>

          {[1, 2, 3, 4, 5].map((idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 18px",
                backgroundColor: "rgba(255, 59, 48, 0.1)",
                borderLeft: "6px solid #FF3B30",
                borderRadius: 10,
                marginBottom: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <TrendingDown size={24} color="#FF3B30" />
                <span
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 30,
                    letterSpacing: 2,
                    color: "#FF3B30",
                    lineHeight: 1,
                  }}
                >
                  DEFEAT
                </span>
              </div>
              <span
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.75)",
                }}
              >
                Ranked Match
              </span>
            </div>
          ))}

          <div
            style={{
              marginTop: 18,
              fontFamily: "'Inter', sans-serif",
              fontSize: 18,
              color: "#FFE600",
              fontWeight: 800,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Bukannya evaluasi... malah top up beli skin baru!
          </div>
        </div>

        {/* Right: Clown Makeup Meme */}
        <div
          style={{
            width: 470,
            backgroundColor: "#161622",
            borderRadius: 30,
            overflow: "hidden",
            border: "2px solid rgba(255,255,255,0.18)",
          }}
        >
          <Img
            src={staticFile("kyustore_3pasien/visuals/clown_makeup.jpg")}
            style={{ width: "100%", height: 440, objectFit: "cover" }}
          />
          <div
            style={{
              padding: 22,
              backgroundColor: "#12121A",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 22,
                fontWeight: 800,
                fontStyle: "italic",
                lineHeight: 1.35,
              }}
            >
              "Mungkin kalau pake skin mahal, damage gue nambah..."
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- SCENE 5: OUTRO (Kyu Store Solution) ---
const OutroScene: React.FC<{ frame: number; fps: number }> = ({ frame, fps }) => {
  const pop = spring({ frame, fps, config: { damping: 11 } });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        transform: `scale(${pop})`,
      }}
    >
      {/* Eyebrow */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 26px",
          backgroundColor: "#5D3FD3",
          borderRadius: 30,
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 26,
          letterSpacing: 2,
          color: "#FFFFFF",
          marginBottom: 22,
        }}
      >
        <Zap size={22} color="#FFE600" />
        SOLUSI TOP UP SAT-SET
      </div>

      {/* Main Logo Display */}
      <div
        style={{
          padding: "26px 56px",
          backgroundColor: "rgba(93, 63, 211, 0.22)",
          border: "2px solid rgba(123, 92, 250, 0.65)",
          borderRadius: 32,
          marginBottom: 24,
          boxShadow: "0 22px 60px rgba(93, 63, 211, 0.35)",
        }}
      >
        <Img
          src={staticFile("kyustore_3pasien/visuals/kyu_logo_white.png")}
          style={{ height: 100, objectFit: "contain" }}
        />
      </div>

      <h1
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 76,
          fontWeight: 400,
          lineHeight: 1,
          letterSpacing: 2.5,
          margin: 0,
          marginBottom: 32,
        }}
      >
        TOP UP GAK PAKE DRAMA RIBET
      </h1>

      {/* 3 Value Pillars */}
      <div
        style={{
          display: "flex",
          gap: 20,
          width: "100%",
          justifyContent: "center",
          marginBottom: 40,
        }}
      >
        {[
          {
            icon: Zap,
            title: "PROSES SAT-SET",
            sub: "Detik itu juga masuk",
            color: "#FFE600",
          },
          {
            icon: ShieldCheck,
            title: "100% LEGAL & AMAN",
            sub: "Anti diamond minus",
            color: "#00E676",
          },
          {
            icon: CheckCircle2,
            title: "SEMUA GAME ADA",
            sub: "MLBB, FF, Valo, dll",
            color: "#CB62F9",
          },
        ].map((item, idx) => {
          const Icon = item.icon;
          return (
            <div
              key={idx}
              style={{
                flex: 1,
                padding: "24px 18px",
                backgroundColor: "rgba(255,255,255,0.06)",
                border: "1.5px solid rgba(255,255,255,0.16)",
                borderRadius: 24,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: 54,
                  height: 54,
                  borderRadius: 16,
                  backgroundColor: "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 14px",
                }}
              >
                <Icon size={28} color={item.color} />
              </div>
              <div
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 32,
                  letterSpacing: 1.5,
                  marginBottom: 6,
                }}
              >
                {item.title}
              </div>
              <div
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 16,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.7)",
                }}
              >
                {item.sub}
              </div>
            </div>
          );
        })}
      </div>

      {/* CTA Button */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 16,
          padding: "22px 56px",
          backgroundColor: "#5D3FD3",
          borderRadius: 40,
          boxShadow: "0 18px 46px rgba(93, 63, 211, 0.75)",
        }}
      >
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 40,
            letterSpacing: 2,
            color: "#FFF",
          }}
        >
          CEK LINK DI BIO SEKARANG
        </span>
        <ArrowRight size={34} color="#FFF" />
      </div>
    </div>
  );
};
